import type { FeatureEvents, UIEvent } from '../new-analytics-types';
import { Action, ActionSubject } from '../new-analytics-types';
import { orgProductListScreen } from './user-management-event-data';

type UiKeys =
  | 'enterpriseQuotingBannerCard'
  | 'whatsStrategyCollectionBanner'
  | 'appPromoBannerMoreActions'
  | 'appPromoBannerMoreActionsSelectOption'
  | 'whatsTeamworkCollectionTwcBanner'
  | 'appPromoBanner'
  | 'teamworkCollectionBanner';

export const collectionBannerEvents: FeatureEvents<string, UiKeys, string, string> = {
  confluenceSpec: [
    'https://hello.atlassian.net/wiki/spaces/CLOUDADMIN/pages/4832211151/Analytics+Spec+TWC+View+Collection',
    'https://hello.atlassian.net/wiki/spaces/CLOUDADMIN/pages/5367059435/AX+-+Strategy+Collection+-+Analytic+Spec',
  ],
  screen: {},
  ui: {
    teamworkCollectionBanner: (): UIEvent => ({
      data: {
        action: Action.Viewed,
        actionSubject: ActionSubject.Banner,
        actionSubjectId: 'teamworkCollectionBanner',
        source: orgProductListScreen,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/80298',
    }),
    appPromoBanner: (attributes: { appType: string }): UIEvent => ({
      data: {
        action: Action.Viewed,
        actionSubject: ActionSubject.Banner,
        actionSubjectId: 'appPromoBanner',
        source: orgProductListScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/85495',
    }),
    enterpriseQuotingBannerCard: (attributes: { appType: string; source: string }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Card,
        actionSubjectId: 'enterpriseQuotingBannerCard',
        source: attributes.source,
        attributes: {
          appType: attributes.appType,
        },
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/59169',
    }),
    whatsTeamworkCollectionTwcBanner: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Link,
        actionSubjectId: 'whatsTeamworkCollectionTwcBanner',
        source: orgProductListScreen,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/79802',
    }),
    whatsStrategyCollectionBanner: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Link,
        actionSubjectId: 'whatsStrategyCollectionBanner',
        source: orgProductListScreen,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/85481',
    }),
    appPromoBannerMoreActions: (attributes: { appType: string }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'appPromoBannerMoreActions',
        source: orgProductListScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/85483',
    }),
    appPromoBannerMoreActionsSelectOption: (attributes: { appType: string; selectedOption: string }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Option,
        actionSubjectId: 'appPromoBannerMoreActionsSelectOption',
        source: orgProductListScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/85485',
    }),
  },
  track: {},
  operational: {},
};
